// extracted by mini-css-extract-plugin
export default {"button":"SubmitButton_button__AT5Ig","spinner":"SubmitButton_spinner__vPMi2","spin":"SubmitButton_spin__2uU2M","icon":"SubmitButton_icon__bV-By"};